(function () {
  'use strict';

  function getVariants(productSection) {
    var el = productSection.querySelector('[data-variant-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || el.value); } catch (e) { return null; }
  }

  function getSelections(block) {
    var selections = {};
    block.querySelectorAll('[data-variant-input]:checked').forEach(function (input) {
      selections[input.dataset.index] = input.value;
    });
    return selections;
  }

  function updateAvailability(block, variants) {
    var selections = getSelections(block);
    block.querySelectorAll('.variant-input-wrap').forEach(function (fieldset) {
      var fieldsetIndex = fieldset.dataset.index;
      fieldset.querySelectorAll('[data-variant-input]').forEach(function (input) {
        var testValue = input.value;
        var testSelections = {};
        Object.keys(selections).forEach(function (k) { testSelections[k] = selections[k]; });
        testSelections[fieldsetIndex] = testValue;
        var available = variants.some(function (v) {
          if (testSelections['option1'] && v.option1 !== testSelections['option1']) return false;
          if (testSelections['option2'] && v.option2 !== testSelections['option2']) return false;
          if (testSelections['option3'] && v.option3 !== testSelections['option3']) return false;
          return v.available;
        });
        var label = input.nextElementSibling;
        if (available) {
          input.classList.remove('disabled');
          if (label) label.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
          if (label) label.classList.add('disabled');
        }
      });
    });
  }

  function initSection(productSection) {
    var variants = getVariants(productSection);
    if (!variants) return;
    var block = productSection.querySelector('[data-dynamic-variants-enabled]');
    if (!block) return;
    block.addEventListener('change', function () {
      requestAnimationFrame(function () { updateAvailability(block, variants); });
    });
    requestAnimationFrame(function () { updateAvailability(block, variants); });
  }

  function init() {
    document.querySelectorAll('[data-section-type="product"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector('[data-section-type="product"]');
    if (section) initSection(section);
  });

})();
